import { useMemo, useState } from 'react'
import { NavLink } from 'react-router-dom'

import { selectProcessDocumentContact, selectProcessDocumentCurrentUser } from '../../../store/processDocument/documentUsers'
import { selectProcessDocumentFileInfo } from '../../../store/processDocument/documentInfo'
import { useAppSelector } from '../../../store/hooks'

import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'

import { IntegrationExportButton } from '../../../components/IntegrationExportButton/IntegrationExportButton'
import buttonStyles from '../../../components/Button/Button.module.scss'
import { UserAvatar } from '../../../components/UserAvatar/UserAvatar'

import { DOCUMENT_CONTACT_UPDATE_SUPPORTED_INTEGRATIONS, IntegrationServiceId } from '../../../common/integrations'

import { UpdateExternalDocumentContactModal } from '../UpdateExternalDocumentContactModal/UpdateExternalDocumentContactModal'

export const DocumentSummaryContacts = () => {
  const currentUser = useAppSelector(selectProcessDocumentCurrentUser)
  const contact = useAppSelector(selectProcessDocumentContact)
  const fileInfo = useAppSelector(selectProcessDocumentFileInfo)

  const [selectedIntegrationType, setSelectedIntegrationType] = useState<IntegrationServiceId | null>(null)

  const contactUpdateSupportedUserIntegrations = useMemo(
    () =>
      currentUser?.integrations?.filter(({ serviceId }) => DOCUMENT_CONTACT_UPDATE_SUPPORTED_INTEGRATIONS.includes(serviceId as IntegrationServiceId)) ?? [],
    [currentUser],
  )

  const handleHideModal = () => {
    setSelectedIntegrationType(null)
  }

  if (!contact || !fileInfo) {
    return null
  }

  return (
    <>
      {selectedIntegrationType ? (
        <UpdateExternalDocumentContactModal
          serviceId={selectedIntegrationType}
          user={contact}
          fileId={fileInfo.fileId}
          show={true}
          onCancel={handleHideModal}
          onSave={handleHideModal}
        />
      ) : null}
      <div className='p-4 zocks-border-0.5 border zocks-border-color-gray-300 d-flex flex-column gap-4'>
        <div className='d-flex align-items-center justify-content-between'>
          <span className='paragraph-large bold'>Clients</span>
        </div>
        <div className='d-flex flex-column gap-4'>
          <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
            <div className='d-flex align-items-center gap-3'>
              <UserAvatar
                width='1.5rem'
                height='1.5rem'
                fontSize='0.75rem'
                className='zocks-bg-color-gray-900 zocks-text-white'
                useInitials={true}
                initialLetters={contact.name ? contact.name[0] : ''}
              />
              <NavLink
                className={`${buttonStyles.button} ${buttonStyles.linkButton} button-link-medium `}
                to={`/library/manage-contacts/contacts/${contact.id}`}
                target='_blank'
              >
                <div className='paragraph-medium-extended bold text-truncate mw-100'>
                  <div className='text-truncate'>{getUserDisplayName(contact)}</div>
                </div>
              </NavLink>
            </div>
            <div className='d-flex align-items-center gap-2'>
              {contactUpdateSupportedUserIntegrations.map(({ serviceId }) => (
                <IntegrationExportButton key={serviceId} serviceId={serviceId} onClick={() => setSelectedIntegrationType(serviceId as IntegrationServiceId)} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
